export default "__VITE_ASSET__BLcIR8u0__"